export const shortestQueueSelectAllOptions = (type?: string) => ({
  id: 0,
  value: "",
  label: type === "province" ? "cała Polska" : "wszystkie",
});
